var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.256796 0.477997C0.598412 0.133125 1.15223 0.130754 1.49384 0.480367L9.11899 8.26429C9.4606 8.61271 9.45944 9.17565 9.11666 9.52171C8.94643 9.69355 8.72258 9.78125 8.49988 9.78125C8.27486 9.78125 8.051 9.69355 7.88078 9.51934L0.25563 1.73542C-0.0859864 1.38699 -0.0848201 0.824054 0.256796 0.477997ZM15.505 0.480485C15.8466 0.130873 16.4004 0.133243 16.742 0.478115C17.0848 0.824173 17.086 1.38711 16.7455 1.73554L11.6819 6.90506C11.5117 7.07928 11.2867 7.16698 11.0628 7.16698C10.8401 7.16698 10.6163 7.07928 10.446 6.90743C10.1033 6.56138 10.1021 5.99844 10.4425 5.65001L15.505 0.480485Z",
    fill: "#4569FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.b3aefe00.svg";
export { ForwardRef as ReactComponent };